import { useCallback, useState } from 'react';
import { Flex, FlexItem } from '@bigcommerce/big-design';
import { StatusSelect } from './StatusSelect';
import { TagRemoveWarning } from './tagRemoveWarning';
import { CHILD_TAG_OPTIONS, TAG_OPTIONS, TagsSelect } from './TagsSelect';
import { ORDER_ACTIONS, TAG_TYPES } from '../hooks/useOrderEditState';

export default function Attributes({
	orderStatus,
	selectedTags,
	selectedChildTags,
	orderDispatch,
	imageUploadUrl,
}) {
	const [tagBeingRemoved, setRemoving] = useState(null);
	const [tagType, setType] = useState(null);
	const removeTag = (type, tag) => {
		orderDispatch({
			type: ORDER_ACTIONS.REMOVE_TAG,
			data: { type, tag },
		});
		setRemoving(null);
		setType(null);
	};
	const onSelectTags = useCallback(
		(type, existingTags) => (updatedTags) => {
			updatedTags
				.filter((tag) => !existingTags.includes(tag))
				.forEach((tag) =>
					orderDispatch({
						type: ORDER_ACTIONS.ADD_TAG,
						data: { type, tag },
					}),
				);
			existingTags
				.filter((tag) => !updatedTags.includes(tag))
				.forEach((tag) => {
					if (!tagBeingRemoved) {
						setRemoving(tag);
						setType(type);
					}
				});
		},
		[orderDispatch],
	);
	return (
		<FlexItem padding="xSmall" paddingLeft="none" paddingRight="none">
			<Flex flexWrap="wrap" style={{ rowGap: '0.5rem' }}>
				<FlexItem flexBasis={'20%'}>
					<StatusSelect
						onOptionChange={(newStatus) =>
							orderDispatch({
								type: ORDER_ACTIONS.UPDATE_STATUS,
								data: newStatus,
							})
						}
						value={orderStatus}
					/>
				</FlexItem>
				<FlexItem flexGrow={1} flexBasis={'20%'} paddingRight="xLarge">
					<TagsSelect
						tags={selectedTags}
						onTagsChanged={onSelectTags(
							TAG_TYPES.TAGS,
							selectedTags,
						)}
						label="Tags: "
						options={TAG_OPTIONS}
						placeholder="Add Tag"
					/>
				</FlexItem>
				<FlexItem flexGrow={1} flexBasis={'20%'}>
					<TagsSelect
						tags={selectedChildTags}
						onTagsChanged={onSelectTags(
							TAG_TYPES.CHILD_TAGS,
							selectedChildTags,
						)}
						label="Child Tags: "
						options={CHILD_TAG_OPTIONS}
						placeholder="Add Tag"
					/>
				</FlexItem>
			</Flex>
			{tagBeingRemoved !== null && (
				<TagRemoveWarning
					onCancel={() => setRemoving(null)}
					onComplete={() => removeTag(tagType, tagBeingRemoved)}
				/>
			)}
		</FlexItem>
	);
}
